var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "act-sayhi-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _vm.env.isApp
        ? _c(
            "div",
            {
              staticClass: "custom-nav-block",
              style: `padding-top:${_vm.barHeight}px`,
            },
            [
              _c("van-nav-bar", {
                staticClass: "van-bar",
                attrs: { title: "", "left-arrow": "" },
                on: { "click-left": _vm.closeWeb },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "left",
                      fn: function () {
                        return [
                          _c("img", {
                            staticClass: "left-nav",
                            attrs: {
                              src: require("@/assets/packageAssets/common/arrow01.png"),
                              alt: "",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1638547946
                ),
              }),
            ],
            1
          )
        : _c("div", { staticStyle: { width: "100%", height: "40px" } }),
      _c(
        "div",
        { staticClass: "sayhi-content" },
        [
          _c("MyPLabel", {
            staticClass: "sayhi-head",
            attrs: {
              str: _vm.$t("lang.commonM.k064"),
              customClass: { bean: "sayhi-head-beans" },
            },
          }),
          _vm.since && _vm.until
            ? _c("p", { staticClass: "sayhi-date" }, [
                _vm._v(
                  _vm._s(_vm.handleMoment(_vm.since, "DD/MM/YYYY")) +
                    " - " +
                    _vm._s(_vm.handleMoment(_vm.until, "DD/MM/YYYY"))
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "sayhi-bg", on: { click: _vm.handleClaim } },
            [
              _c("img", {
                staticClass: "sayhi-bg-icon1",
                attrs: { src: _vm.getMatchImg("beans") },
              }),
              _c("img", {
                staticClass: "sayhi-bg-icon2",
                attrs: { src: _vm.getMatchImg("beans") },
              }),
              _vm.actStatus === "CLAIMED"
                ? [
                    _c("img", {
                      staticClass: "sayhi-bg-main",
                      attrs: { src: require("./images/gift-box-open.png") },
                    }),
                    _c("img", {
                      staticClass: "sayhi-bg-tips",
                      attrs: { src: require("./images/tips-arrow.png") },
                    }),
                    _c("div", { staticClass: "sayhi-claimed" }, [
                      _vm._v(_vm._s(_vm.$t("lang.commonM.k074"))),
                    ]),
                  ]
                : [
                    _c("img", {
                      staticClass: "sayhi-bg-main",
                      class: { "can-claim": _vm.actStatus === "APPROVED" },
                      attrs: { src: require("./images/gift-box-close.png") },
                    }),
                  ],
            ],
            2
          ),
          _c("p", { staticClass: "sayhi-tips" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k065"))),
          ]),
          _c("van-uploader", {
            ref: "vanUploader",
            staticStyle: {
              position: "fixed",
              top: "100px",
              left: "0",
              "z-index": "-1",
            },
            attrs: {
              accept: "video/mp4,video/ogg,video/webm",
              "after-read": _vm.afterRead,
            },
          }),
          _vm.actStatus === "NONE"
            ? _c("div", { staticClass: "sayhi-upload no-video-block" }, [
                _c("div", { staticClass: "upload-btns" }, [
                  _c(
                    "button",
                    {
                      staticClass: "upload-yellow",
                      on: { click: _vm.chooseFile },
                    },
                    [
                      _c("img", {
                        attrs: { src: require("./images/upload-icon.png") },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k071")) + " "),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "upload-tips-txt" }, [
                  _vm._v(" 1. "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k066")))]),
                ]),
                _c("div", { staticClass: "upload-tips-txt" }, [
                  _vm._v(" 2. "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k067")))]),
                ]),
                _c("div", { staticClass: "upload-tips-txt" }, [
                  _vm._v(" 3. "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k068")))]),
                ]),
              ])
            : _vm._e(),
          _vm.actStatus === "REJECTED"
            ? _c("div", { staticClass: "sayhi-upload no-video-block" }, [
                _c("p", { staticClass: "reject-txt" }, [
                  _vm._v(_vm._s(_vm.$t("lang.commonM.k076"))),
                ]),
                _c("div", { staticClass: "upload-btns" }, [
                  _c(
                    "button",
                    {
                      staticClass: "upload-yellow",
                      on: { click: _vm.chooseFile },
                    },
                    [
                      _c("img", {
                        attrs: { src: require("./images/upload-icon.png") },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k072")) + " "),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "upload-tips-txt" }, [
                  _vm._v(" 1. "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k066")))]),
                ]),
                _c("div", { staticClass: "upload-tips-txt" }, [
                  _vm._v(" 2. "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k067")))]),
                ]),
                _c("div", { staticClass: "upload-tips-txt" }, [
                  _vm._v(" 3. "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k068")))]),
                ]),
              ])
            : _vm._e(),
          _vm.actStatus === "PENDING"
            ? _c("div", { staticClass: "sayhi-upload" }, [
                _c(
                  "div",
                  {
                    staticClass: "upload-video",
                    on: {
                      click: function ($event) {
                        return _vm.handleShowVideo(_vm.uploadedVideoUrl)
                      },
                    },
                  },
                  [_c("img", { attrs: { src: _vm.thumbnail } })]
                ),
                _c("div", { staticClass: "upload-btns" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k075")))]),
                  _c(
                    "button",
                    {
                      staticClass: "upload-yellow",
                      on: { click: _vm.chooseFile },
                    },
                    [
                      _c("img", {
                        attrs: { src: require("./images/upload-icon.png") },
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k072")) + " "),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.actStatus === "APPROVED"
            ? _c("div", { staticClass: "sayhi-upload" }, [
                _c(
                  "div",
                  {
                    staticClass: "upload-video",
                    on: {
                      click: function ($event) {
                        return _vm.handleShowVideo(_vm.uploadedVideoUrl)
                      },
                    },
                  },
                  [_c("img", { attrs: { src: _vm.thumbnail } })]
                ),
                _c("div", { staticClass: "upload-btns" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k077")))]),
                  _c(
                    "button",
                    {
                      staticClass: "upload-yellow",
                      on: { click: _vm.handleClaim },
                    },
                    [_vm._v(_vm._s(_vm.$t("lang.commonM.k073")))]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.actStatus === "CLAIMED"
            ? _c("div", { staticClass: "sayhi-upload" }, [
                _c(
                  "div",
                  {
                    staticClass: "upload-video",
                    on: {
                      click: function ($event) {
                        return _vm.handleShowVideo(_vm.uploadedVideoUrl)
                      },
                    },
                  },
                  [_c("img", { attrs: { src: _vm.thumbnail } })]
                ),
                _c("div", { staticClass: "upload-btns" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("lang.commonM.k077")))]),
                  _c("button", [_vm._v(_vm._s(_vm.$t("lang.commonM.k074")))]),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "videos-title" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k070"))),
          ]),
          _c(
            "div",
            { staticClass: "videos-block" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "video-item",
                  on: {
                    click: function ($event) {
                      return _vm.handleShowVideo(item.url)
                    },
                  },
                },
                [_c("img", { attrs: { src: item.thumbnail } })]
              )
            }),
            0
          ),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "is-loading" },
                [_c("van-loading", { attrs: { size: "24px" } })],
                1
              )
            : _vm._e(),
          !_vm.loading && _vm.finished
            ? _c("div", { staticClass: "no-more" }, [
                _vm._v(_vm._s(_vm.$t("lang.noMore"))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm.isUploading
        ? _c(
            "div",
            { staticClass: "upload-mask" },
            [
              _c("van-circle", {
                attrs: {
                  rate: _vm.percent,
                  speed: "100",
                  size: "75",
                  fill: "#fafafa",
                  color: "#f7a704",
                  "stroke-width": "80",
                  text: `${_vm.percent}%`,
                },
                model: {
                  value: _vm.percent,
                  callback: function ($$v) {
                    _vm.percent = $$v
                  },
                  expression: "percent",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "cancel-upload",
                  on: { click: _vm.cancelUpload },
                },
                [_vm._v("×")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showVideo
        ? _c(
            "div",
            { staticClass: "upload-mask", on: { click: _vm.handleClosePlay } },
            [
              _c("div", { staticClass: "will-play" }, [
                _c("video", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: _vm.currentVideo,
                    controls: "",
                    muted: "",
                    autoplay: "",
                  },
                  domProps: { muted: true },
                }),
                _c(
                  "div",
                  {
                    staticClass: "cancel-play",
                    on: { click: _vm.handleClosePlay },
                  },
                  [_vm._v("×")]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "van-popup",
        {
          staticClass: "van-popup-box",
          attrs: { "lock-scroll": false },
          on: { close: _vm.closeShowRewardDia },
          model: {
            value: _vm.showRewardDia,
            callback: function ($$v) {
              _vm.showRewardDia = $$v
            },
            expression: "showRewardDia",
          },
        },
        [
          _c("div", { staticClass: "reward-dia" }, [
            _c("img", {
              staticClass: "bulibuli",
              attrs: { src: _vm.getMatchImg("reward-bg"), alt: "" },
            }),
            _c("span", { staticClass: "number" }, [
              _c("i", [_vm._v("x")]),
              _vm._v(" " + _vm._s(_vm.rewardNumber) + " "),
            ]),
          ]),
          _c("div", { staticClass: "reward-dia-btn" }, [
            _c("span", { on: { click: _vm.closeShowRewardDia } }, [
              _vm._v(_vm._s(_vm.$t("lang.confirm"))),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }